/** Asset 360 / Site 360 (tracker 39), under assets:report360. See locales/en-US/report360.ts. */
export const report360 = {
  ui: {
    finding: "Hallazgo",
    versionPrepared: "Versión {{version}} · preparada el {{date}}",
    kindAsset: "Asset 360",
    kindSite: "Site 360",
    kindVersion: "{{kind}} · versión {{version}}",
    preparedFor: "Preparado para {{name}}",
    writtenFor: "Redactado para: {{reader}}",
    prepared: "Preparado el {{date}}",
    figuresAsOf: "cifras a {{date}}",
    wordsByAi: "Explicaciones redactadas por IA (Google Gemini) a partir de las cifras de la aplicación. La IA nunca cambia una cifra.",
    wordsByApp: "Redactado por la aplicación a partir de sus registros.",
    verdictTitle: "Valoración general",
    contents: "Índice",
    contentsLine: "{{number}}. {{title}}",
    contentsTail: "Después: plan de acción, calidad de los datos y acerca de este informe.",
    summaryTitle: "Resumen ejecutivo",
    keyFindings: "Hallazgos principales",
    doFirst: "Qué hacer primero",
    bullet: "• {{text}}",
    scorecardTitle: "Cuadro de indicadores",
    noData: "Aún sin datos",
    change30d: "{{value}} en 30 días",
    sectionTitle: "{{number}}. {{title}}",
    whatItMeans: "Qué significa",
    actionsTitle: "Plan de acción",
    actionsNone: "Ahora mismo no hay nada que hacer.",
    priority1: "Ahora",
    priority2: "Después",
    priority3: "Cuando pueda",
    due_one: "En {{count}} día",
    due_other: "En {{count}} días",
    due_many: "En {{count}} días",
    raiseJob: "Crear un trabajo",
    raiseInspection: "Iniciar una inspección",
    open: "Abrir",
    dataQualityTitle: "Calidad de los datos",
    dataQualityIntro: "Hasta qué punto este informe puede apoyarse en sus registros. Las carencias reducen la fiabilidad de cada sección.",
    cannotJudge: "Lo que el informe no pudo valorar",
    getMoreTitle: "Saque más partido a este informe",
    getMoreIntro: "Solo usted ve esto. Nunca aparece en lo que comparte.",
    aboutTitle: "Acerca de este informe",
    coverage: "Hay {{recorded}} de {{total}} tipos de registro.",
    coverageMissing: "Aún sin registrar: {{list}}.",
    aboutAsset_one: "Las puntuaciones proceden de las cifras nocturnas; los trabajos y las inspecciones abarcan el último {{count}} día.",
    aboutAsset_other: "Las puntuaciones proceden de las cifras nocturnas; los trabajos y las inspecciones abarcan los últimos {{count}} días.",
    aboutAsset_many: "Las puntuaciones proceden de las cifras nocturnas; los trabajos y las inspecciones abarcan los últimos {{count}} días.",
    aboutSite_one: "Las puntuaciones proceden del resumen nocturno de la ubicación; los trabajos abarcan el último {{count}} día.",
    aboutSite_other: "Las puntuaciones proceden del resumen nocturno de la ubicación; los trabajos abarcan los últimos {{count}} días.",
    aboutSite_many: "Las puntuaciones proceden del resumen nocturno de la ubicación; los trabajos abarcan los últimos {{count}} días.",
    aboutAi: "La IA redactó el resumen y las explicaciones para el lector elegido. Cada cifra, valoración y hallazgo es de la aplicación.",
    highRisk: "riesgo alto",
    nothingToShow: "Aún no hay nada que mostrar.",
    labelValue: "{{label}}: {{value}}",
    whereItSits: "Dónde está",
    dependsOn: "Depende de",
    serves: "Da servicio a",
    none: "Nada registrado",
    singlePoints: "Punto único de fallo: {{names}}",
    hiddenLinks_one: "{{count}} vínculo más que no puede abrir",
    hiddenLinks_other: "{{count}} vínculos más que no puede abrir",
    hiddenLinks_many: "{{count}} vínculos más que no puede abrir",
    prepareTitle: "Preparar el informe",
    readerLabel: "¿Para quién es?",
    readerA11y: "Redactar el informe para: {{reader}}",
    hideNames: "Ocultar los nombres de los contratistas",
    hideNamesHint: "Muestra los contratistas como Contratista A, B, etc.",
    preparedForLabel: "Preparado para (opcional)",
    preparedForPlaceholder: "Por ejemplo, Inmobiliaria del Puerto S.L.",
    storyTitle: "Versión con IA",
    storyHint: "Google Gemini reescribe el resumen y cada explicación para su lector, en el idioma que elija. Nunca cambia una cifra.",
    languageLabel: "Idioma",
    focusLabel: "En qué debe centrarse la IA",
    pickFocus: "Elija al menos una sección en la que deba centrarse la IA.",
    weakData: "La calidad de los datos es baja ({{score}} de 100). La IA dirá lo que no puede valorar en lugar de adivinar.",
    generate: "Redactar la versión con IA",
    chargedWhenWritten: "El crédito se descuenta solo cuando el informe está redactado. Si falla, no se cobra nada.",
    queuedTitle: "Su versión con IA está en cola",
    queuedBody: "Puesto {{position}} en la cola. Puede salir de esta página: recibirá una notificación cuando esté lista.",
    runningTitle: "Redactando su versión con IA…",
    runningBody: "Suele tardar menos de un minuto. Puede salir de esta página: recibirá una notificación cuando esté lista.",
    failedTitle: "No se pudo redactar la versión con IA",
    failedBody: "No se ha cobrado nada. Inténtelo de nuevo en un momento.",
    joined: "Alguien ya pidió este informe, así que ambos recibirán el mismo.",
    showingAi: "Versión con IA {{version}}, redactada el {{date}}",
    showingApp: "Versión de la aplicación para este lector",
    showApp: "Ver la versión de la aplicación",
    showAi: "Ver la versión con IA",
    loading: "Preparando el informe…",
    loadFailed: "No se pudo abrir el informe.",
    busy: "Los informes están muy solicitados ahora. Inténtelo de nuevo en un momento.",
    retry: "Reintentar",
    requestFailedTitle: "No se pudo pedir la versión con IA",
    earlierTitle: "Antes de Asset 360",
    earlierHint: "Informes con IA redactados antes de Asset 360 y Site 360. Toque una fecha para leerlo.",
    shareTitle: "{{kind}}: {{name}}",
  },
  reader: {
    asset_manager: "Gestor de activos",
    client: "Cliente",
    landlord: "Propietario",
    site_manager: "Responsable de la ubicación",
    investor: "Inversor",
  },
  readerHint: {
    asset_manager: "La imagen completa, desde el entorno hasta los trabajos, con todas las secciones.",
    client: "Trabajos y contratistas primero: qué se hizo, con qué calidad y a tiempo.",
    landlord: "Cumplimiento y riesgo primero. Los nombres de los contratistas se ocultan salvo que los active.",
    site_manager: "Trabajos y estado primero, con el plan de acción justo después del resumen.",
    investor: "Unas dos páginas: valoración, cuadro de indicadores, riesgo, cumplimiento y las acciones principales.",
  },
  rating: {
    on_track: "En buen camino",
    watch: "A vigilar",
    needs_attention: "Requiere atención",
  },
  confidence: {
    high: "Fiabilidad: alta",
    medium: "Fiabilidad: media",
    low: "Fiabilidad: baja",
  },
  dqBand: {
    strong: "Buena",
    fair: "Aceptable",
    weak: "Baja",
  },
  dimension: {
    complete: "Completos",
    current: "Al día",
    evidenced: "Justificados",
    connected: "Vinculados",
    consistent: "Coherentes",
  },
  scorecard: {
    asset: {
      compliance: "Cumplimiento",
      risk: "Riesgo",
      condition: "Estado",
      inspections_on_time: "Inspecciones a tiempo",
      right_first_time: "Bien a la primera",
      overdue_work: "Trabajos vencidos",
    },
    site: {
      compliance: "Cumplimiento",
      risk: "Riesgo medio",
      condition: "Estado",
      inspections_on_time: "Activos inspeccionados este año",
      right_first_time: "Bien a la primera",
      overdue_work: "Trabajos vencidos",
    },
  },
  section: {
    environment: "Dónde está y qué lo rodea",
    compliance: "Cumplimiento",
    risk: "Riesgo",
    condition: "Estado e inspecciones",
    work: "Trabajos",
    contractors: "Contratistas",
    property: "El inmueble",
    areas: "Edificios y zonas",
    inspections: "Inspecciones",
    siteRisk: "Riesgo en toda la ubicación",
  },
  finding: {
    environment: {
      noSite: "No está asignado a ninguna ubicación, así que se desconoce su entorno.",
      site: "Está en {{site}}, donde {{atRisk}} de {{assets}} activos están en riesgo y {{overdue}} trabajos están vencidos.",
      siteNoSummary: "Está en {{site}}, que aún no tiene resumen nocturno.",
    },
    compliance: {
      expired_one: "Un certificado o documento ha caducado.",
      expired_other: "{{count}} certificados o documentos han caducado.",
      expired_many: "{{count}} certificados o documentos han caducado.",
      expiring_one: "Un certificado caduca en los próximos 60 días.",
      expiring_other: "{{count}} certificados caducan en los próximos 60 días.",
      expiring_many: "{{count}} certificados caducan en los próximos 60 días.",
      noDocuments: "El cumplimiento está en {{score}}, pero no hay certificados archivados que lo respalden.",
      noFigures: "Aún no hay cifras de cumplimiento guardadas.",
      ok_one: "El cumplimiento está en {{score}}, con {{count}} documento archivado y nada caducado.",
      ok_other: "El cumplimiento está en {{score}}, con {{count}} documentos archivados y nada caducado.",
      ok_many: "El cumplimiento está en {{score}}, con {{count}} documentos archivados y nada caducado.",
      site: "El cumplimiento en toda la ubicación está en {{score}}.",
      siteExpired_one: "Un documento ha caducado en la ubicación.",
      siteExpired_other: "{{count}} documentos han caducado en la ubicación.",
      siteExpired_many: "{{count}} documentos han caducado en la ubicación.",
    },
    condition: {
      health: "El estado es {{score}} ({{band}}). Días desde la última inspección: {{days}}.",
      inspected: "Aún no hay puntuación de estado. Días desde la última inspección: {{days}}.",
      neverInspected: "Nunca se ha inspeccionado, así que se desconoce su estado actual.",
      overdueChecks_one: "Una revisión programada está vencida.",
      overdueChecks_other: "{{count}} revisiones programadas están vencidas.",
      overdueChecks_many: "{{count}} revisiones programadas están vencidas.",
    },
    contractors: {
      none: "Ningún contratista ha trabajado aquí en este periodo.",
      summary_one: "Un contratista hizo {{jobs}} trabajos: {{busiest}}.",
      summary_other: "{{count}} contratistas hicieron {{jobs}} trabajos. El más activo fue {{busiest}}.",
      summary_many: "{{count}} contratistas hicieron {{jobs}} trabajos. El más activo fue {{busiest}}.",
    },
    inspections: {
      noSummary: "Aún no hay resumen de inspecciones para esta ubicación.",
      site: "Se inspeccionaron {{inspected}} de {{assets}} activos este año. {{failed}} de {{inspections}} inspecciones de los últimos 90 días encontraron problemas.",
    },
    property: {
      noSummary: "La ubicación tiene {{assets}} activos. Aún no hay resumen nocturno.",
      summary: "La ubicación tiene {{assets}} activos. {{atRisk}} están en riesgo y hay {{open}} trabajos abiertos.",
    },
    risk: {
      level: "El riesgo es {{level}} ({{score}} de 25).",
      neighbours_one: "El riesgo es {{level}} ({{score}} de 25), y un activo vinculado tiene riesgo alto.",
      neighbours_other: "El riesgo es {{level}} ({{score}} de 25), y {{count}} activos vinculados tienen riesgo alto.",
      neighbours_many: "El riesgo es {{level}} ({{score}} de 25), y {{count}} activos vinculados tienen riesgo alto.",
      notAssessed: "No se ha hecho ninguna evaluación de riesgos.",
      singlePoint: "El riesgo es {{level}} ({{score}} de 25), y {{name}} es un punto único de fallo.",
      site: "El riesgo medio es {{level}} ({{score}} de 25). {{atRisk}} activos están en riesgo.",
      siteNotAssessed: "Los activos de la ubicación no tienen evaluación de riesgos.",
    },
    work: {
      none: "No se crearon trabajos en los últimos 12 meses.",
      ok: "Se hicieron {{done}} trabajos en los últimos 12 meses, ninguno vencido ni devuelto.",
      overdue_one: "Un trabajo está vencido. Se hicieron {{done}} trabajos en los últimos 12 meses.",
      overdue_other: "{{count}} trabajos están vencidos. Se hicieron {{done}} trabajos en los últimos 12 meses.",
      overdue_many: "{{count}} trabajos están vencidos. Se hicieron {{done}} trabajos en los últimos 12 meses.",
      rework_one: "Se devolvió uno de {{done}} trabajos terminados ({{pct}} % bien a la primera).",
      rework_other: "Se devolvieron {{count}} de {{done}} trabajos terminados ({{pct}} % bien a la primera).",
      rework_many: "Se devolvieron {{count}} de {{done}} trabajos terminados ({{pct}} % bien a la primera).",
      siteNone: "No se crearon trabajos en los activos de la ubicación en los últimos 90 días.",
      siteOk: "Se hicieron {{done}} trabajos en los últimos 90 días y no se devolvió ninguno.",
      siteRework_one: "Se devolvió uno de {{done}} trabajos terminados en los últimos 90 días ({{pct}} % bien a la primera).",
      siteRework_other: "Se devolvieron {{count}} de {{done}} trabajos terminados en los últimos 90 días ({{pct}} % bien a la primera).",
      siteRework_many: "Se devolvieron {{count}} de {{done}} trabajos terminados en los últimos 90 días ({{pct}} % bien a la primera).",
    },
    areas: {
      none: "No hay edificios ni zonas registrados en la ubicación. Ubicaciones dentro: {{n}}.",
      summary_one: "Hay un edificio o zona registrado; {{top}} tiene {{assets}} activos.",
      summary_other: "Hay {{count}} edificios y zonas registrados. El mayor, {{top}}, tiene {{assets}} activos.",
      summary_many: "Hay {{count}} edificios y zonas registrados. El mayor, {{top}}, tiene {{assets}} activos.",
    },
  },
  meaning: {
    environment: {
      noSite: "Sin ubicación, el informe no puede decir qué lo rodea ni qué supondría un problema cercano.",
      ok: "Su entorno está en buen estado, así que es poco probable que lo que lo rodea agrave un problema aquí.",
      siteWeak: "La ubicación tiene problemas abiertos. Los trabajos cercanos pueden afectarle y sus propios fallos pesan más.",
      neighboursRisk_one: "Un activo vinculado tiene riesgo alto, así que un fallo allí podría alcanzar a este activo.",
      neighboursRisk_other: "{{count}} activos vinculados tienen riesgo alto, así que un fallo allí podría alcanzar a este activo.",
      neighboursRisk_many: "{{count}} activos vinculados tienen riesgo alto, así que un fallo allí podría alcanzar a este activo.",
    },
    compliance: {
      on_track: "La documentación está en orden. Renueve a tiempo y seguirá así.",
      watch: "El cumplimiento empeora. Renueve lo que vence antes de que se convierta en una incidencia.",
      needs_attention: "El cumplimiento requiere atención ya: un inspector o una aseguradora lo señalaría.",
      none: "Aún no hay cifras de cumplimiento con las que valorarlo.",
      expired: "Un certificado caducado puede hacer que su uso no sea legal ni esté asegurado hasta renovarlo.",
      noDocuments: "Sin documentos archivados, la puntuación no se puede demostrar a quien la pida.",
      awaitingCheck_one: "Un documento espera revisión, así que aún no cuenta.",
      awaitingCheck_other: "{{count}} documentos esperan revisión, así que aún no cuentan.",
      awaitingCheck_many: "{{count}} documentos esperan revisión, así que aún no cuentan.",
    },
    risk: {
      on_track: "El riesgo es bajo. Basta con el cuidado normal y las revisiones programadas.",
      watch: "El riesgo es moderado. Mantenga las revisiones a tiempo y vigile los cambios.",
      needs_attention: "El riesgo es alto. Un fallo sería costoso o peligroso: siga el plan de abajo.",
      notAssessed: "Sin evaluación de riesgos, nadie puede decir cuánto importaría un fallo.",
      noLinks: "El riesgo es {{level}}. No hay vínculos con otros activos, así que se desconocen los efectos en cadena.",
      singlePoint: "Otros activos dependen de él sin respaldo, así que un fallo aquí también los detiene.",
    },
    condition: {
      on_track: "Está en buen estado y se inspecciona a tiempo.",
      watch: "Su estado empieza a empeorar. Esté atento a la próxima inspección.",
      needs_attention: "Su estado es malo. Planifique la reparación o la sustitución.",
      none: "Aún no hay puntuación de estado con la que valorarlo.",
      neverInspected: "Nadie lo ha revisado en la aplicación, así que su estado es una suposición hasta que se inspeccione.",
      issues_one: "Una inspección reciente encontró problemas que requieren seguimiento.",
      issues_other: "{{count}} inspecciones recientes encontraron problemas que requieren seguimiento.",
      issues_many: "{{count}} inspecciones recientes encontraron problemas que requieren seguimiento.",
      repeat: "«{{item}}» se repite una y otra vez. Corregir la causa ahorraría visitas repetidas.",
    },
    work: {
      none: "No haber trabajos significa que no hizo falta nada o que los trabajos no se registran en la aplicación.",
      ok: "Los trabajos se hacen a tiempo y bien a la primera.",
      overdue: "Los trabajos vencidos dejan problemas conocidos sin resolver y aumentan el riesgo.",
      rework: "Los trabajos devueltos cuestan una segunda visita y retrasan la solución.",
    },
    contractors: {
      none: "No hay trabajos de contratistas registrados, así que no se puede valorar su rendimiento.",
      good: "Los contratistas terminan a tiempo y lo hacen bien a la primera.",
      late_one: "Un contratista suele terminar tarde.",
      late_other: "{{count}} contratistas suelen terminar tarde.",
      late_many: "{{count}} contratistas suelen terminar tarde.",
      sentBack_one: "A un contratista le han devuelto trabajos.",
      sentBack_other: "A {{count}} contratistas les han devuelto trabajos.",
      sentBack_many: "A {{count}} contratistas les han devuelto trabajos.",
      offApp_one: "Un contratista no usa la aplicación, así que sus trabajos tienen menos pruebas.",
      offApp_other: "{{count}} contratistas no usan la aplicación, así que sus trabajos tienen menos pruebas.",
      offApp_many: "{{count}} contratistas no usan la aplicación, así que sus trabajos tienen menos pruebas.",
    },
    property: {
      on_track: "El inmueble está en buen estado en general.",
      watch: "El inmueble está mayormente en orden, con algunas zonas a vigilar.",
      needs_attention: "El inmueble requiere atención: el cumplimiento o el estado está por debajo de lo debido.",
      truncated: "Esta ubicación tiene {{n}} activos; el informe lee los primeros 5.000.",
    },
    areas: {
      none: "Sin edificios ni zonas, el informe no puede mostrar dónde se concentran los problemas.",
      ok: "Ningún edificio ni zona destaca como problema.",
      highRisk: "Los activos de riesgo alto se concentran en {{area}}. Empiece por ahí.",
    },
    inspections: {
      on_track: "Casi todos los activos se han inspeccionado este año.",
      watch: "Algunos activos no se han inspeccionado este año.",
      needs_attention: "Muchos activos no se han inspeccionado este año, así que se desconoce su estado.",
      none: "Aún no hay resumen de inspecciones con el que valorarlo.",
      overdue: "Hay revisiones programadas vencidas. Póngase al día antes de que se pasen problemas por alto.",
    },
  },
  basis: {
    environment: {
      summary: "Según el resumen nocturno de la ubicación del {{date}}.",
      noSummary: "Según la ficha de la ubicación; aún no tiene resumen nocturno.",
    },
    site: {
      summary: "Según el resumen nocturno del {{date}}.",
    },
    compliance: "Según las cifras nocturnas y los documentos archivados ({{n}}).",
    risk: "Según la última evaluación de riesgos y los vínculos con otros activos ({{links}}).",
    condition: "Según las cifras nocturnas de estado y las inspecciones recientes ({{n}}).",
    work: {
      year: "Según los trabajos de los últimos 12 meses ({{n}}).",
      ninetyDays: "Según los trabajos de los últimos 90 días ({{n}}).",
    },
    contractors: {
      year: "Según los trabajos de contratistas de los últimos 12 meses ({{n}}).",
      ninetyDays: "Según los trabajos de contratistas de los últimos 90 días ({{n}}).",
    },
    areas: "Según los lugares registrados en la ubicación y los activos que contienen ({{n}}).",
    siteRisk: "Según las evaluaciones de riesgos de los activos de la ubicación ({{n}}).",
  },
  score: {
    compliance: {
      on_track: "Sin incidencias: documentación en orden.",
      watch: "Algunos documentos por renovar o ausentes.",
      needs_attention: "Documentos caducados o ausentes.",
      none: "Aún sin cifras.",
    },
    risk: {
      on_track: "Riesgo bajo.",
      watch: "Riesgo moderado.",
      needs_attention: "Riesgo alto.",
      none: "Sin evaluar.",
    },
    condition: {
      on_track: "Buen estado.",
      watch: "Estado en declive.",
      needs_attention: "Mal estado.",
      none: "Aún sin cifras de estado.",
    },
    inspectionsOnTime: {
      on_track: "Revisiones programadas hechas a tiempo.",
      watch: "Algunas revisiones con retraso.",
      needs_attention: "Muchas revisiones con retraso.",
      none: "Sin revisiones programadas.",
    },
    inspectedThisYear: {
      on_track: "Casi todos los activos inspeccionados este año.",
      watch: "Algunos activos sin inspeccionar este año.",
      needs_attention: "Muchos activos sin inspeccionar este año.",
      none: "Aún sin resumen de inspecciones.",
    },
    rightFirstTime: {
      on_track: "Trabajos bien a la primera.",
      watch: "Algunos trabajos devueltos.",
      needs_attention: "Muchos trabajos devueltos.",
      none: "No hay trabajos terminados que valorar.",
    },
    overdueWork: {
      on_track: "Nada vencido.",
      watch: "Trabajos pasada su fecha: {{n}}.",
      needs_attention: "Trabajos pasada su fecha: {{n}}.",
      none: "Sin trabajos registrados.",
    },
  },
  band: {
    posture: {
      on_track: "Sin incidencias",
      watch: "A vigilar",
      needs_attention: "Actuar",
    },
    risk: {
      low: "bajo",
      medium: "medio",
      high: "alto",
      extreme: "extremo",
    },
  },
  verdict: {
    on_track: "En buen camino: {{reason}}",
    watch: "A vigilar: {{reason}}",
    needs_attention: "Requiere atención: {{reason}}",
    on_track_all: "En buen camino: todos los indicadores están en orden.",
  },
  reason: {
    compliance: "el cumplimiento está en {{value}}.",
    risk: "el riesgo está en {{value}} de 25.",
    condition: "el estado está en {{value}}.",
    inspections_on_time: "el {{value}} % de las inspecciones va a tiempo.",
    right_first_time: "el {{value}} % de los trabajos sale bien a la primera.",
    overdue_work: "trabajos pasada su fecha: {{value}}.",
  },
  stat: {
    jobsWithSubJobs: "Trabajos con subtrabajos",
    familiesOnTime: "De ellos, a tiempo",
    waitBetweenSteps: "Espera entre pasos",
    stepsSentBack: "Pasos devueltos",
    hoursValue: "{{n}} h",
    assets: "Activos",
    assetsAtRisk: "Activos en riesgo",
    checksDone: "Revisiones hechas",
    checksNext60: "Revisiones en los próximos 60 días",
    checksOverdue: "Revisiones vencidas",
    checksPlanned: "Revisiones programadas",
    expiredDocuments: "Documentos caducados",
    failed90d: "Inspecciones con problemas (90 días)",
    inspectedThisYear: "Inspeccionados este año",
    inspections90d: "Inspecciones (90 días)",
    jobsDone: "Trabajos hechos",
    links: "Activos vinculados",
    neighbours: "Activos cercanos",
    onTime: "A tiempo",
    openJobs: "Trabajos abiertos",
    overdueJobs: "Trabajos vencidos",
    rejected: "Rechazados",
    rescheduled: "Reprogramados",
    rightFirstTime: "Bien a la primera",
    sentBack: "Devueltos",
    siteAtRisk: "Activos de la ubicación en riesgo",
    siteCompliance: "Cumplimiento de la ubicación",
    siteHealth: "Estado de la ubicación",
    siteOverdueJobs: "Trabajos vencidos en la ubicación",
  },
  col: {
    area: "Zona",
    asset: "Activo",
    assets: "Activos",
    avgDays: "Días de media",
    contractor: "Contratista",
    date: "Fecha",
    document: "Documento",
    expires: "Caduca",
    highRisk: "Riesgo alto",
    issues: "Problemas",
    job: "Trabajo",
    jobs: "Trabajos",
    kind: "Tipo",
    level: "Nivel",
    onTime: "A tiempo",
    reason: "Motivo",
    result: "Resultado",
    risk: "Riesgo",
    sentBack: "Devueltos",
    site: "Ubicación",
    status: "Estado",
    usesApp: "Usa la aplicación",
  },
  visual: {
    areas: "Edificios y zonas",
    byZone: "Activos por zona",
    childSites: "Ubicaciones dentro de esta",
    complianceTrend: "Cumplimiento, últimos 90 días",
    contractors: "Contratistas",
    documents: "Documentos",
    healthTrend: "Estado, últimos 90 días",
    openJobsTrend: "Trabajos abiertos, últimos 90 días",
    recentInspections: "Inspecciones recientes",
    repeatItems: "Fallos que se repiten",
    rework: "Por qué se devolvieron trabajos",
    riskTrend: "Riesgo, últimos 90 días",
    topRisk: "Activos de mayor riesgo",
  },
  docStatus: {
    awaitingCheck: "Pendiente de revisión",
    expired: "Caducado",
    expiring: "Caduca pronto",
    valid: "Válido",
  },
  result: {
    issues: "Con problemas",
    passed: "Superada",
    open: "Sin terminar",
  },
  common: {
    yes: "Sí",
    no: "No",
    noReason: "Sin motivo indicado",
    noExpiry: "Sin caducidad",
  },
  contractors: {
    anonymous: "Contratista {{letter}}",
  },
  action: {
    planReplacement: "Planificar la sustitución de {{name}}",
    backup: "Prever un respaldo para {{name}}",
    clearOverdue_one: "Resolver el trabajo vencido",
    clearOverdue_other: "Resolver los {{count}} trabajos vencidos",
    clearOverdue_many: "Resolver los {{count}} trabajos vencidos",
    fillDetails: "Completar los datos que faltan",
    fillSiteDetails: "Completar los datos que faltan de la ubicación",
    inspect: "Inspeccionar {{name}}",
    inspectRest_one: "Inspeccionar el activo que no se ha inspeccionado este año",
    inspectRest_other: "Inspeccionar los {{count}} activos que no se han inspeccionado este año",
    inspectRest_many: "Inspeccionar los {{count}} activos que no se han inspeccionado este año",
    overdueChecks_one: "Hacer la revisión vencida",
    overdueChecks_other: "Hacer las {{count}} revisiones vencidas",
    overdueChecks_many: "Hacer las {{count}} revisiones vencidas",
    renewExpired_one: "Renovar el certificado caducado",
    renewExpired_other: "Renovar los {{count}} certificados caducados",
    renewExpired_many: "Renovar los {{count}} certificados caducados",
    renewExpiring_one: "Renovar el certificado que caduca pronto",
    renewExpiring_other: "Renovar los {{count}} certificados que caducan pronto",
    renewExpiring_many: "Renovar los {{count}} certificados que caducan pronto",
    repeatFault: "Encontrar la causa de «{{item}}»",
    reviewRisk: "Revisar el riesgo de {{name}}",
    rework: "Hablar con los contratistas sobre los trabajos devueltos",
  },
  why: {
    pastLife: "Ha superado su vida útil prevista.",
    spendHigh: "Un año de reparaciones ha costado la mitad o más de uno nuevo.",
    backup: "Otros activos dependen de él sin respaldo.",
    clearOverdue: "Los trabajos vencidos dejan problemas conocidos sin resolver.",
    fillDetails: "La calidad de los datos es {{score}} de 100, lo que limita lo que puede decir el informe.",
    neverInspected: "Su estado se desconoce hasta que alguien lo revise.",
    overdueChecks: "Hay revisiones programadas fuera de plazo.",
    renewExpired: "Un certificado caducado puede hacer que su uso sea ilegal o no esté asegurado.",
    renewExpiring: "Renovar antes de la caducidad evita quedarse sin cobertura.",
    repeatFault_one: "Ya necesitó un trabajo una vez.",
    repeatFault_other: "Ha necesitado un trabajo {{count}} veces.",
    repeatFault_many: "Ha necesitado un trabajo {{count}} veces.",
    reviewRisk: "Su riesgo es {{level}}.",
    rework_one: "Se devolvió un trabajo.",
    rework_other: "Se devolvieron {{count}} trabajos.",
    rework_many: "Se devolvieron {{count}} trabajos.",
  },
  jobTitle: {
    planReplacement: "Planificar sustitución",
    findCause: "Encontrar la causa del fallo repetido: {{item}}",
    renewCertificates: "Renovar certificados caducados",
    riskReview: "Revisión de riesgos",
  },
  getMore: {
    addValue: "Añada cuándo se instaló, cuánto debe durar y cuánto cuesta sustituirlo, para que el informe muestre su vida y su valor.",
    addValueButton: "Añadir valor y vida útil",
    addDetails: "Complete los datos que faltan para mejorar la calidad de los datos y la fiabilidad de cada sección.",
    addDetailsButton: "Editar el activo",
    addSiteDetails: "Complete los datos que faltan de la ubicación para mejorar la calidad de los datos.",
    addSiteDetailsButton: "Editar la ubicación",
    groupRule: "Cree una regla de grupo para que los activos como este reciban las revisiones adecuadas automáticamente.",
    groupRuleButton: "Abrir las reglas de grupo",
    inviteContractor: "Invite a sus contratistas para que sus trabajos queden registrados con pruebas.",
    inviteContractorButton: "Invitar a un contratista",
    linkAssets: "Vincúlelo a los activos de los que depende o a los que da servicio, para ver el riesgo en cadena.",
    linkAssetsButton: "Añadir vínculos",
    placeAssets: "Coloque los activos de la ubicación en edificios y zonas para ver los problemas por lugar.",
    placeAssetsButton: "Abrir la ubicación",
    placeOnSite: "Asígnelo a una ubicación para que el informe pueda describir su entorno.",
    placeOnSiteButton: "Elegir una ubicación",
    scheduleInspection: "Programe una inspección para conocer su estado.",
    scheduleInspectionButton: "Programar una inspección",
    siteAddress: "Añada la dirección o el punto en el mapa de la ubicación.",
    siteAddressButton: "Añadir la dirección",
    uploadCertificate: "Suba sus certificados para poder demostrar el cumplimiento.",
    uploadCertificateButton: "Subir un documento",
  },
  coverage: {
    asset: {
      site: "una ubicación",
      place: "dónde está",
      links: "vínculos con otros activos",
      documents: "documentos",
      inspection: "una inspección este año",
      risk: "una evaluación de riesgos",
      criticality: "la criticidad",
      figures: "cifras nocturnas",
      work: "historial de trabajos",
      schedule: "revisiones programadas",
    },
    site: {
      address: "una dirección o un punto en el mapa",
      summary: "un resumen nocturno",
      areas: "edificios y zonas",
      inspected: "inspecciones de casi todos los activos",
      assessed: "evaluaciones de riesgos de casi todos los activos",
      evidence: "pruebas de casi todos los activos",
      contractors: "trabajos de contratistas",
      located: "la posición de los activos en el mapa",
    },
  },
  gaps: {
    missingField: "Sin valor para {{field}}.",
    neverInspected: "Nunca inspeccionado, así que se desconoce su estado actual.",
    inspectedLongAgo: "Última inspección hace {{days}} días, así que su estado puede haber cambiado.",
    noInspectionThisYear: "Ninguna inspección terminada en los últimos 12 meses.",
    noDocuments: "No hay documentos (certificados, manuales, garantías) archivados.",
    noPhotos: "Sin fotos.",
    noRiskAssessment: "No se ha hecho ninguna evaluación de riesgos.",
    noSite: "No está asignado a ninguna ubicación, así que no se puede describir su entorno.",
    noLocation: "Sin posición en el mapa.",
    noLinks: "No está vinculado a ningún activo relacionado, así que se desconocen los efectos en cadena.",
    retiredWithOpenJobs_one: "Marcado como {{status}}, pero aún tiene {{count}} trabajo abierto.",
    retiredWithOpenJobs_other: "Marcado como {{status}}, pero aún tiene {{count}} trabajos abiertos.",
    retiredWithOpenJobs_many: "Marcado como {{status}}, pero aún tiene {{count}} trabajos abiertos.",
    riskWithoutCriticality: "Tiene puntuación de riesgo pero no criticidad, así que la puntuación usa un valor por defecto.",
    zonesWithoutSite: "Tiene zonas pero no ubicación, así que las zonas no pertenecen a nada.",
    noStoredFigures: "Aún no hay cifras diarias guardadas, así que no se pueden mostrar tendencias.",
    staleFigures: "Las cifras diarias guardadas tienen {{days}} días.",
    missingFieldOnAssets_one: "Sin valor para {{field}} en {{count}} de {{total}} activos.",
    missingFieldOnAssets_other: "Sin valor para {{field}} en {{count}} de {{total}} activos.",
    missingFieldOnAssets_many: "Sin valor para {{field}} en {{count}} de {{total}} activos.",
    noAssets: "No hay activos en esta ubicación.",
    assetsNotInspected_one: "{{count}} de {{total}} activos no se ha inspeccionado en los últimos 12 meses.",
    assetsNotInspected_other: "{{count}} de {{total}} activos no se han inspeccionado en los últimos 12 meses.",
    assetsNotInspected_many: "{{count}} de {{total}} activos no se han inspeccionado en los últimos 12 meses.",
    noInspectionHistory: "Aún no hay historial de inspecciones resumido para esta ubicación.",
    assetsWithNothing_one: "Un activo no tiene nada registrado.",
    assetsWithNothing_other: "{{count}} activos no tienen nada registrado.",
    assetsWithNothing_many: "{{count}} activos no tienen nada registrado.",
    assetsNotAssessed_one: "Un activo no tiene evaluación de riesgos.",
    assetsNotAssessed_other: "{{count}} activos no tienen evaluación de riesgos.",
    assetsNotAssessed_many: "{{count}} activos no tienen evaluación de riesgos.",
    siteNotLocated: "La ubicación no tiene dirección ni posición en el mapa.",
    assetsNotLocated_one: "{{count}} de {{total}} activos no tiene posición en el mapa.",
    assetsNotLocated_other: "{{count}} de {{total}} activos no tienen posición en el mapa.",
    assetsNotLocated_many: "{{count}} de {{total}} activos no tienen posición en el mapa.",
    noSiteSummary: "Aún no hay resumen de la ubicación guardado, así que no se pueden mostrar tendencias.",
    staleSiteSummary: "El resumen de la ubicación guardado tiene {{days}} días.",
    assetCountMoved_one: "La ubicación tiene ahora {{count}} activo, pero el resumen de anoche contó {{summarised}}.",
    assetCountMoved_other: "La ubicación tiene ahora {{count}} activos, pero el resumen de anoche contó {{summarised}}.",
    assetCountMoved_many: "La ubicación tiene ahora {{count}} activos, pero el resumen de anoche contó {{summarised}}.",
    assetsRiskWithoutCriticality_one: "Un activo tiene puntuación de riesgo pero no criticidad.",
    assetsRiskWithoutCriticality_other: "{{count}} activos tienen puntuación de riesgo pero no criticidad.",
    assetsRiskWithoutCriticality_many: "{{count}} activos tienen puntuación de riesgo pero no criticidad.",
  },
  versions: {
    title: "Versiones",
    hint: "Cada versión guardada queda tal como era. Abra una para leerla o compararla con la anterior.",
    none: "Aún no hay versiones guardadas. Guarde esta versión, o pida la versión con IA, para empezar la lista.",
    save: "Guardar esta versión",
    saveFailed: "No se pudo guardar la versión",
    savedTitle: "Guardada",
    savedBody: "Guardada como versión {{version}}.",
    label: "Versión {{version}} · {{date}}",
    ai: "Redactada por la IA",
    app: "Las cifras de la aplicación",
    open: "Abrir",
    close: "Cerrar",
    viewing: "Está leyendo la versión {{version}}, guardada el {{date}}.",
    backToCurrent: "Volver al informe actual",
  },
  compare: {
    title: "Qué cambió de la versión {{older}} a la versión {{newer}}",
    show: "Comparar con la versión {{version}}",
    hide: "Ocultar la comparación",
    verdict: "Veredicto: {{before}} → {{after}} ({{movement}})",
    dataQuality: "Calidad de datos: {{before}} → {{after}} ({{movement}})",
    figure: "{{before}} → {{after}} ({{movement}})",
    actionsAdded: "Acciones nuevas: {{n}}",
    actionsGone: "Acciones que ya no hacen falta: {{n}}",
    bullet: "• {{text}}",
    movement: {
      better: "mejor",
      worse: "peor",
      same: "sin cambios",
      new: "nuevo",
      gone: "ya no aparece",
    },
  },
  share: {
    open: "Compartir",
    title: "Compartir este informe",
    hint: "Se le avisa en la aplicación y por correo. El enlace abre el informe en AssetWRX: la portada y el cuadro de mando al momento, el resto tras iniciar sesión o crear una cuenta gratuita.",
    toLabel: "Enviar a",
    toPlaceholder: "Busque contactos o escriba un correo electrónico",
    messageLabel: "Mensaje (opcional)",
    messagePlaceholder: "Añadir una nota para el destinatario...",
    savesFirst: "Lo que ve en pantalla se guarda primero como una versión nueva, para que lea exactamente esto.",
    send: "Enviar informe",
    sentTitle: "Compartido",
    sentBody: "La versión {{version}} se ha compartido con {{who}}.",
    failedTitle: "No se pudo compartir",
    failedBody: "Algo ha fallado. Inténtelo de nuevo.",
    sharedWith: "Compartido con",
    versionOn: "Versión {{version}} · {{date}}",
    read: "Leído el {{date}}",
    notRead: "Aún sin leer",
    withdrawn: "Retirado",
    replaced: "Sustituido por una versión más reciente",
    sendNew: "Enviar la versión {{version}}",
    withdraw: "Retirar",
    close: "Cerrar",
  },
  download: {
    pdf: "Descargar PDF",
    csv: "Descargar CSV",
    approverOnly: "Solo quien aprueba los trabajos de este activo puede descargar. Use Compartir para enviarlo a alguien.",
  },
  csv: {
    similarMiddle: "Punto medio de similares",
    basis: "Basado en",
    part: "Parte",
    item: "Elemento",
    value: "Valor",
    band: "Valoración",
    note: "Nota",
    subject: "Objeto",
    version: "Versión",
    written: "Redactado",
    reader: "Redactado para",
  },
  shared: {
    header: "Informe compartido",
    loadFailed: "No se pudo cargar el informe.",
    notFound: "Este enlace no lleva a ningún informe.",
    goToApp: "Ir a AssetWRX",
    revoked: "Este informe ya no se comparte con usted.",
    replaced: "Se ha compartido con usted una versión más reciente de este informe.",
    openNewer: "Abrir la versión más reciente",
    notYours: "Este informe se compartió con otra persona. Inicie sesión con la dirección a la que se envió.",
    verdict: "Veredicto: {{rating}}",
    gateTitle: "Leer el informe completo",
    gateBody: "Inicie sesión, o cree una cuenta gratuita, para leer todas las secciones, el plan de acción y la calidad de datos.",
    signIn: "Iniciar sesión",
    createAccount: "Crear una cuenta gratuita",
    sharedBy: "Compartido por {{who}} el {{date}}",
    sharedOn: "Compartido el {{date}}",
    note: "Su mensaje: {{message}}",
    newerExists: "Hay una versión más reciente (versión {{version}}). Pídasela a quien lo envió si la necesita.",
    readOnly: "Solo lectura. Este informe queda tal como era al compartirse.",
  },
  comparison: {
    title: "Cómo se compara",
    measure: {
      compliance: "Cumplimiento",
      condition: "Estado",
      risk: "Riesgo",
      right_first_time: "Bien a la primera",
    },
    position: {
      better: "mejor que la mayoría",
      similar: "parecido a la mayoría",
      worse: "por detrás de la mayoría",
    },
    row: "{{value}}, {{position}} (punto medio de similares: {{middle}})",
    notEnough: "Muy pocos similares tienen este dato para comparar.",
    basis: {
      asset_one: "Comparado con 1 activo similar que puede ver, con las cifras de anoche.",
      asset_other: "Comparado con {{count}} activos similares que puede ver, con las cifras de anoche.",
      asset_many: "Comparado con {{count}} activos similares que puede ver, con las cifras de anoche.",
      site_one: "Comparado con 1 otro emplazamiento que puede ver, con las cifras de anoche.",
      site_other: "Comparado con {{count}} otros emplazamientos que puede ver, con las cifras de anoche.",
      site_many: "Comparado con {{count}} otros emplazamientos que puede ver, con las cifras de anoche.",
    },
    finding: {
      behind: "Por detrás de la mayoría de similares en {{measure}}.",
      ahead: "Por delante de la mayoría de similares en {{measure}}.",
      inLine: "En línea con los similares.",
    },
  },
  value: {
    title: "Valor y vida útil",
    measure: {
      installed_on: "Instalado",
      age: "Antigüedad",
      expected_life: "Vida útil prevista",
      remaining_life: "Vida restante",
      purchase_cost: "Coste de compra",
      replacement_cost: "Coste de sustitución",
      spend: "Gastado en trabajos",
      spend_share: "Gasto respecto al coste de sustitución",
      replacement_total: "Valor de sustitución registrado",
      assets_with_value: "Activos con coste de sustitución",
      past_life: "Activos que superan su vida útil",
    },
    years_one: "{{value}} año",
    years_other: "{{value}} años",
    years_many: "{{value}} años",
    lifeUsed: "{{pct}} % de su vida útil prevista consumida",
    finding: {
      pastLife: "Ha superado su vida útil prevista en {{years}} años.",
      spendHigh: "Un año de trabajos costó el {{pct}} % de sustituirlo. Sustituir puede costar menos que reparar.",
      nearEnd: "Ha consumido el {{pct}} % de su vida útil prevista.",
      lifeLeft: "Le quedan unos {{years}} años de vida útil prevista.",
      recorded: "Lo registrado sobre su valor.",
      sitePastLife_one: "1 de {{of}} activos con vida útil registrada la ha superado.",
      sitePastLife_other: "{{count}} de {{of}} activos con vida útil registrada la han superado.",
      sitePastLife_many: "{{count}} de {{of}} activos con vida útil registrada la han superado.",
      siteRecorded_one: "1 de {{of}} activos tiene coste de sustitución registrado.",
      siteRecorded_other: "{{count}} de {{of}} activos tienen coste de sustitución registrado.",
      siteRecorded_many: "{{count}} de {{of}} activos tienen coste de sustitución registrado.",
      siteSpendOnly: "Lo que han costado los trabajos del emplazamiento.",
    },
    spendBasis: {
      year: "Gasto de los últimos 12 meses, de {{withCost}} de {{jobs}} trabajos terminados con coste.",
      ninetyDays: "Gasto de los últimos 90 días, de {{withCost}} de {{jobs}} trabajos terminados con coste.",
    },
    marketTitle: "Precio habitual de mercado",
    marketHint: "De fuentes en línea, no comprobado por AssetWRX.",
  },
esg: {
section: "Energía, carbono y sostenibilidad (ESG)",
basis: "A partir de las lecturas de contadores de los últimos 24 meses, el refrigerante y los certificados energéticos registrados y los factores de carbono del Gobierno británico ({{year}}). El carbono es una estimación.",
ratingsTable: "Certificados energéticos",
col: {
certificate: "Certificado",
rating: "Calificación",
},
finding: {
belowMinimum: "Certificados energéticos por debajo del mínimo para alquilar (E): {{n}}.",
fgasOverdue: "Controles de fugas de gases fluorados vencidos: {{n}}.",
noMeters: "No hay contadores de energía registrados, así que no se pueden medir la energía ni el carbono.",
energyChange: "{{kwh}} kWh usados en los últimos 12 meses ({{change}} % respecto al año anterior), unas {{tonnes}} t CO₂e.",
energy: "{{kwh}} kWh usados en los últimos 12 meses, unas {{tonnes}} t CO₂e.",
},
meaning: {
belowMinimum: "Un edificio en Inglaterra y Gales no puede alquilarse por debajo de E sin una exención. Planifique la mejora o registre una exención.",
fgasOverdue: "Los controles vencidos incumplen la normativa de gases fluorados y dejan escapar refrigerante, un potente gas de efecto invernadero.",
noMeters: "Sin contadores, el consumo y el carbono se desconocen. Añada contadores y tome lecturas.",
noFloorArea: "Añada la superficie para comparar el consumo por m² con otros edificios.",
ok: "La energía y el carbono se están midiendo. Mantenga las lecturas regulares para que las cifras estén completas.",
},
stat: {
energy: "Energía, kWh (12 meses)",
change: "Cambio anual, %",
intensity: "kWh por m²",
carbon: "Carbono, t CO₂e",
scope1: "Alcance 1, t CO₂e",
scope2: "Alcance 2, t CO₂e",
water: "Agua, m³",
meters: "Contadores con lectura",
refrigerant: "Refrigerante, t CO₂e",
fgasOverdue: "Controles de gases F vencidos",
},
status: {
belowMinimum: "Por debajo del mínimo para alquilar",
expired: "Caducado",
expiresSoon: "Caduca en menos de 6 meses",
valid: "Válido",
},
action: {
improveEpc: "Planificar obras para subir la calificación energética a E o mejor",
fgasOverdue: "Realizar los controles de fugas vencidos ({{n}})",
renewEpc: "Renovar el certificado energético caducado",
readMeters: "Tomar lecturas de los contadores sin lectura en 3 meses ({{n}})",
},
why: {
improveEpc: "Por debajo de E no puede alquilarse legalmente sin una exención.",
fgasOverdue: "Los controles de fugas son obligatorios con esta cantidad de refrigerante.",
renewEpc: "Se necesita un certificado energético para vender o alquilar.",
readMeters: "Los huecos en las lecturas dejan incompletas las cifras de energía y carbono.",
},
jobTitle: {
improveEpc: "Obras de mejora de la calificación energética",
renewEpc: "Renovar el certificado de eficiencia energética",
},
},
};
